import { render, staticRenderFns } from "./DashboardSavings.vue?vue&type=template&id=e7ab4b94&scoped=true&"
import script from "./DashboardSavings.vue?vue&type=script&lang=js&"
export * from "./DashboardSavings.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSavings.vue?vue&type=style&index=0&id=e7ab4b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ab4b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
